import { connect, ConnectedProps } from "react-redux";
import { useParams } from "react-router-dom";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { IStore } from "../../../store/IStore";
import { CardDesignDto } from "../../../store/models/carddesign/CardDesignDto";
import MenuLayout from "../../app/MenuLayout";
import CardDesignForm from "./CardDesignForm";
import { useTranslation } from "react-i18next";

const emptyCardDesign: CardDesignDto = {
  cardDesignNumber: "",
  externalCardDesignNumber: "",
  name: "",
  defaultCardDesign: false,
  templateName: "",
};

const CardDesignFormPage = (props: ThunkProps) => {
  const { cardDesigns } = props;
  const { id } = useParams<"id">();
  const { t } = useTranslation()
  const cardDesign = cardDesigns.find(
    (cardDesign) => cardDesign.cardDesignNumber === id
  );

  return (
    <MenuLayout headline={id ? t("setup.editCardDesign") : t("setup.createCardDesign")}>
      <CardDesignForm cardDesign={cardDesign || emptyCardDesign} />
    </MenuLayout>
  );
};

const mapStateToProps = (state: IStore) => ({
  cardDesigns: state.identifications.cardDesigns,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators({}, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);
type ThunkProps = ConnectedProps<typeof connector>;
export default connector(CardDesignFormPage);
